export default "__VITE_ASSET__41bea3f5__"